<div class="flex flex-column gap-6">
  <div class="flex flex-column gap-2 align-items-center">
    <div class="text-lg font-semibold">
      Καλώς ορίσατε στην εφαρμογή Άυλων Υποβολών του ΕΟΠΥΥ.
    </div>
    <div class="text-lg">
      Επιλέξτε μία απο τις διαθέσιμες λειτουργίες της εφαρμογής
    </div>
  </div>
  <section class="grid px-1 lg:flex lg:flex-wrap gap-5">
    <ng-container *ngFor="let item of getMenuItems()">
      <ng-container *ngIf="isTileButtonVisible(item)">
        <div class="col-6 md:col-4 p-1 lg:flex-none xl:col-2">
          <app-tile-button [icon]="item.icon" [label]="item.label" (click)="onButtonClick(item)" class="w-full">
          </app-tile-button>
        </div>
      </ng-container>
    </ng-container>
  </section>
</div>